export const getDocumentsHomeLinkLabel = (
  numberOfItems,
  nonemptyLabel,
  emptyLabel,
  formatMessage,
) => {
  if (!numberOfItems) return formatMessage({ id: emptyLabel });

  return formatMessage({ id: nonemptyLabel }, { numberOfItems });
};
